import { Controller, Payload } from "../../controller";
import { ApplicationState } from "../../store";
import { bindActionCreators, Dispatch } from "redux";
import { Config ,initialValueState, ConfigState, ConfigActions } from "./config.model"
import { action } from "typesafe-actions";
import { call, put, takeLatest } from "redux-saga/effects";
import { ResultDb } from "../../services/db";
import { Item, Movimentacao } from "../../data.types";
import { itemController } from "../item/item.controll";
import { movController } from "../movimentacoes/mov.controll";

export interface ConfigViewProps{
    configState:ConfigState
    configActions:ConfigActions
}

class ConfigController extends Controller<Config, ConfigState, ConfigActions> {
    constructor() {
        super(initialValueState.row.type,initialValueState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
            startDocConfig: `@${this.moduloName}/START_DOC_CONFIG`,
            gerarCodigoItem:`@${this.moduloName}/GERAR_CODIGO_ITEM`,
            gerarCodigoMov: `@${this.moduloName}/GERAR_CODIGO_MOV`,
        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
            startDocConfig:()=>action(this.actionsType.startDocConfig, {this:this}),
            gerarCodigoItem:(item)=>action(this.actionsType.gerarCodigoItem,{item,this:this}),
            gerarCodigoMov:(mov)=>action(this.actionsType.gerarCodigoMov,{mov,this:this}),
        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
            takeLatest(this.actionsType.startDocConfig,this.startDocConfigEffects),
            takeLatest(this.actionsType.gerarCodigoItem, this.gerarCodigoItemEffects),
            takeLatest(this.actionsType.gerarCodigoMov, this.gerarCodigoMovEffects)
        ]
    }


    private* startDocConfigEffects(actions:Payload){
        let vm = actions.payload.this as Controller<Config, ConfigState, ConfigActions>
        try {
            let resp:ResultDb<Config> = yield call(vm.db.getDocID, "@CONFIG")
            console.log("resp startDecConfig",resp)
            if(resp.status === "ok"){
                yield put(vm.reducer.resultAfterEffects(
                    {...vm.state,loading:false,row:resp.row,status:resp.status},
                    vm.actionsType.startDocConfig
                ))
            } else {
                //criar o doc config
                let config:Config = {
                    ...vm.getInititalValueState().row
                }
                yield put(vm.reducer.actions.create(config))
                console.log("chamou create config",config)
            }
        } catch (error:any) {
            console.log("error startDocConfigEffects",error);
            let msg = "Ops, ocorreu uma falha em startDocConfigEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error 
            yield put(vm.reducer.resultAfterEffects(
                {...vm.state,loading:false,msg:err,status:"error",error:true,showAlert:true},
                vm.actionsType.startDocConfig
            ))            
        }
    }

    private* gerarCodigoItemEffects(actions:Payload){
        let vm = actions.payload.this as Controller<Config, ConfigState, ConfigActions>
        try {
            console.log("Chamou gerarCodigoItemEffects",actions.payload)
            let item:Item = actions.payload.item;
            let resp:ResultDb<Config> = yield call(vm.db.getDocID, "@CONFIG");
            if(resp.status === "ok"){
                let config = resp.row as Config;
                let codigo_seq = config.seq_cod_item+1
                let codigFormat = codigo_seq.toString();
                for (let i = 0; i < (config.qt_dig_cod_item - codigo_seq.toString().length); i++) {
                    codigFormat = '0'+codigFormat;
                }        
                console.log("Gerou os codigos",[codigo_seq,codigFormat])
                config.seq_cod_item = codigo_seq;
                item.codigo = codigFormat;
                yield put(vm.reducer.actions.update(config));
                yield put(itemController.reducer.actions.update(item));
            } else {
                let msg = "Não foi encontrado a tabela de configuracões, reinicie o aplicativo para o sistema fazer a reparação.";
                yield put(vm.reducer.resultAfterEffects(
                    {...vm.state,loading:false,msg:msg,status:"error",error:true,showAlert:true},
                    vm.actionsType.gerarCodigoItem
                ))                  
            }
        } catch (error:any) {
            let msg = "Ops, ocorreu uma falha em sgerarCodigoItemEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error 
            yield put(vm.reducer.resultAfterEffects(
                {...vm.state,loading:false,msg:err,status:"error",error:true,showAlert:true},
                vm.actionsType.gerarCodigoItem
            ))
        }
    }


    private* gerarCodigoMovEffects(actions:Payload){
        let vm = actions.payload.this as Controller<Config, ConfigState, ConfigActions>
        try {
            console.log("Chamou gerarCodigoMovEffects",actions.payload)
            let mov:Movimentacao = actions.payload.mov;
            let resp:ResultDb<Config> = yield call(vm.db.getDocID, "@CONFIG");
            if(resp.status === "ok"){
                let config = resp.row as Config;
                let codigo_seq = config.seq_cod_mov+1
                let codigFormat = codigo_seq.toString();
                for (let i = 0; i < (config.qt_dig_cod_mov - codigo_seq.toString().length); i++) {
                    codigFormat = '0'+codigFormat;
                }        
                console.log("Gerou os codigos movimentacao",[codigo_seq,codigFormat])
                config.seq_cod_mov = codigo_seq;
                mov.codigo = codigFormat;
                yield put(vm.reducer.actions.update(config));
                yield put(movController.reducer.actions.update(mov));
            } else {
                let msg = "Não foi encontrado a tabela de configuracões, reinicie o aplicativo para o sistema fazer a reparação.";
                yield put(vm.reducer.resultAfterEffects(
                    {...vm.state,loading:false,msg:msg,status:"error",error:true,showAlert:true},
                    vm.actionsType.gerarCodigoMov
                ))                  
            }
        } catch (error:any) {
            let msg = "Ops, ocorreu uma falha em gerarCodigoMovEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error 
            yield put(vm.reducer.resultAfterEffects(
                {...vm.state,loading:false,msg:err,status:"error",error:true,showAlert:true},
                vm.actionsType.gerarCodigoMov
            ))
        }
    }

}

export const configController = new ConfigController()

export const mapStateToConfigProps = (state: ApplicationState) => ({
    configState: state.configState,
})

export const mapDispatchToConfigProps = (dispatch: Dispatch) => ({
    configActions: bindActionCreators({...configController.reducer.actions}, dispatch),
})